/// Documento e endereço brasileiros: máscara, conferência e a lista de UFs.

export const onlyDigits = (value?: string | null): string => (value ?? '').replace(/\D/g, '');

/// 00.000.000/0000-00, montado conforme a pessoa digita.
export const formatCnpj = (value?: string | null): string => {
    const d = onlyDigits(value).slice(0, 14);

    return d
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
};

/// 000.000.000-00, montado conforme a pessoa digita.
export const formatCpf = (value?: string | null): string => {
    const d = onlyDigits(value).slice(0, 11);

    return d
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
};

/// Mesma conta do Cpf.IsValid do servidor.
export const isValidCpf = (value?: string | null): boolean => {
    const d = onlyDigits(value);

    if (d.length !== 11) return false;
    if (/^(\d)\1+$/.test(d)) return false;

    const digit = (length: number) => {
        let sum = 0;

        for (let i = 0; i < length; i++) sum += Number(d[i]) * (length + 1 - i);

        const rest = sum % 11;

        return rest < 2 ? 0 : 11 - rest;
    };

    return digit(9) === Number(d[9]) && digit(10) === Number(d[10]);
};

/// 00000-000.
export const formatCep = (value?: string | null): string => {
    const d = onlyDigits(value).slice(0, 8);

    return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
};

/// Mesma conta do Cnpj.IsValid do servidor; evita ir à Receita com número já errado.
export const isValidCnpj = (value?: string | null): boolean => {
    const d = onlyDigits(value);

    if (d.length !== 14) return false;

    // Todos iguais passam na conta dos verificadores e não existem.
    if (/^(\d)\1+$/.test(d)) return false;

    const digit = (length: number) => {
        let sum = 0;
        let weight = 2;

        for (let i = length - 1; i >= 0; i--) {
            sum += Number(d[i]) * weight;
            weight = weight === 9 ? 2 : weight + 1;
        }

        const rest = sum % 11;

        return rest < 2 ? 0 : 11 - rest;
    };

    return digit(12) === Number(d[12]) && digit(13) === Number(d[13]);
};

/// Sigla e número de cada UF, na ordem do EBrazilianUf do servidor.
export const BRAZIL_UFS: { value: number; label: string }[] = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA',
    'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
].map((label, index) => ({ value: index + 1, label }));

/// ViaCEP e BrasilAPI devolvem a sigla; o formulário guarda o número.
export const ufFromAbbreviation = (abbreviation?: string | null): number | null =>
    BRAZIL_UFS.find((uf) => uf.label === (abbreviation ?? '').toUpperCase())?.value ?? null;
